import api from '../api';

const path = '/common/data/get';
const apiGetItems = (endpoint) => api.get(`${path}/${endpoint}`);

// common
const getCorporateRequest = () => apiGetItems('typeCorporate');
const getStateRequest = () => apiGetItems('state');
const getYearsRequest = () => apiGetItems('year');
const getRegionRequest = () => apiGetItems('region');
const getCityRequest = () => apiGetItems('city');
const getAdvertsListCountRequest = (params) =>
    api.get(`${path}/adverts`, { params });
const moderateTextRequest = (text) => api.post(`${path}/moderate`, { text });
const getVehicleReviewRequest = (vehicleData, lang) =>
    api.post(`${path}/vehicleReview`, { vehicleData, lang });
const generateAiDescriptionRequest = (vehicleData, lang) =>
    api.post(`${path}/aiDescription`, { vehicleData, lang });
const getVehicleOptionsRequest = (vehicleData, availableOptions) =>
    api.post(`${path}/vehicleOptions`, { vehicleData, availableOptions });
const getFuelPricesRequest = () => api.get(`${path}/fuelPrices`);
const translateTextRequest = (text, targetLang) =>
    api.post(`${path}/translate`, { text, targetLang });
// const getCity = region => api.get(`${path}/city`Request, { params: { region } });

// check-auto
const getTypeCheckautoRequest = () => apiGetItems('typeCheckauto');

// vehicle
const getAirbagRequest = () => apiGetItems('airbag');
const getBodyTypeRequest = () => apiGetItems('bodyType');
const getClimateRequest = () => apiGetItems('climate');
const getCameraRequest = () => apiGetItems('camera');
const getVehicleExchangeRequest = () => apiGetItems('exchangeVehicleType');
const getInteriorRequest = () => apiGetItems('interior');
const getVehicleColorRequest = () => apiGetItems('vehicleColor');
const getVehicleColorTypeRequest = () => apiGetItems('vehicleColorType');
const getCruiseRequest = () => apiGetItems('cruise');
const getOwnersRequest = () => apiGetItems('owners');
const getPowerSteeringRequest = () => apiGetItems('powerSteering');
const getRegistrationRequest = () => apiGetItems('vehicleRegistration');
const getSeatsHeatRequest = () => apiGetItems('seatsHeat');
const getSeatsTypeRequest = () => apiGetItems('seatsType');
const getTransmissionRequest = () => apiGetItems('transmission');
const getDriveunitRequest = () => apiGetItems('driveunit');
const getFuelRequest = () => apiGetItems('fuel');

// vehicle pro
const getEngineStateRequest = () => apiGetItems('engineState');
const getBrakesStateRequest = () => apiGetItems('brakeState');
const getInteriorStateRequest = () => apiGetItems('interiorState');
const getSuspensionStateRequest = () => apiGetItems('suspensionState');
const getTransmissionStateRequest = () => apiGetItems('transmissionState');

// services
const getNameServicesRequest = () => apiGetItems('nameService');
const getNamePlacementRequest = () => apiGetItems('namePlacement');
const getTypeServicesRequest = () => apiGetItems('typeService');
const getTypePlacementRequest = () => apiGetItems('typePlacement');

// parts
const getNamePartsRequest = () => apiGetItems('part');
const getStatePartsRequest = () => apiGetItems('stateParts');
const getTypePartsRequest = () => apiGetItems('partsType');
const getAccessoryPartsRequest = () => apiGetItems('accessoryParts');
const getMaintenancePartsRequest = () => apiGetItems('maintenanceParts');
const getBrakesPartsRequest = () => apiGetItems('brakesParts');
const getCarbodyPartsRequest = () => apiGetItems('carbodyParts');
const getHeatingPartsRequest = () => apiGetItems('heatingParts');
const getElectricPartsRequest = () => apiGetItems('electricParts');
const getEnginePartsRequest = () => apiGetItems('engineParts');
const getEquipmentPartsRequest = () => apiGetItems('equipmentParts');
const getGasEquipmentPartsRequest = () => apiGetItems('gasEquipmentParts');
const getInteriorPartsRequest = () => apiGetItems('interiorParts');
const getSuspensionPartsRequest = () => apiGetItems('suspensionParts');
const getTransmissionPartsRequest = () => apiGetItems('transmissionParts');
const getTyreSeasonRequest = () => apiGetItems('tyreSeason');
const getWheelsPartsRequest = () => apiGetItems('wheelsParts');
const getWheelsRadiusRequest = () => apiGetItems('wheelsRadius');
const getWheelsWidthRequest = () => apiGetItems('wheelsWidth');
const getWheelsBoltsRequest = () => apiGetItems('wheelsBolts');
const getMainStatsRequest = () => apiGetItems('mainStats');

export {
    generateAiDescriptionRequest,
    getVehicleOptionsRequest,
    getFuelPricesRequest,
    getVehicleReviewRequest,
    getAdvertsListCountRequest,
    getAccessoryPartsRequest,
    getAirbagRequest,
    getBodyTypeRequest,
    getBrakesPartsRequest,
    getBrakesStateRequest,
    getCameraRequest,
    getCarbodyPartsRequest,
    getCityRequest,
    getClimateRequest,
    getCorporateRequest,
    getCruiseRequest,
    getDriveunitRequest,
    getElectricPartsRequest,
    getEnginePartsRequest,
    getEngineStateRequest,
    getEquipmentPartsRequest,
    getFuelRequest,
    getGasEquipmentPartsRequest,
    getHeatingPartsRequest,
    getInteriorPartsRequest,
    getInteriorRequest,
    getInteriorStateRequest,
    getMainStatsRequest,
    getMaintenancePartsRequest,
    getNamePartsRequest,
    getNamePlacementRequest,
    getNameServicesRequest,
    getOwnersRequest,
    getPowerSteeringRequest,
    getRegionRequest,
    getRegistrationRequest,
    getSeatsHeatRequest,
    getSeatsTypeRequest,
    getStatePartsRequest,
    getStateRequest,
    getSuspensionPartsRequest,
    getSuspensionStateRequest,
    getTransmissionPartsRequest,
    getTransmissionRequest,
    getTransmissionStateRequest,
    getTypeCheckautoRequest,
    getTypePartsRequest,
    getTypePlacementRequest,
    getTypeServicesRequest,
    getTyreSeasonRequest,
    getVehicleColorRequest,
    getVehicleColorTypeRequest,
    getVehicleExchangeRequest,
    getWheelsBoltsRequest,
    getWheelsPartsRequest,
    getWheelsRadiusRequest,
    getWheelsWidthRequest,
    getYearsRequest,
    moderateTextRequest,
    translateTextRequest,
};
